import {
  Component,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  OnInit,
} from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-dialog-container',
    template: `
    <div
      class=" tw-px-4 tw-pt-2 tw-pb-3 tw-text-[14px] tw-bg-white tw-flex tw-flex-col tw-h-full tw-max-h-full"
      >
      @if (showHeader) {
        <app-action-row
          class=" tw-flex-shrink-0"
          [hasTwoColHeader]="twoColHeader"
          >
          @if (headerLevel === 2) {
            <h2
              [id]="headerId"
              left1
              role="heading"
              class="app-header-2 tw-text-wrap"
              >
              {{ label | translation: translationRequest }}
            </h2>
          }
          @if (headerLevel === 3) {
            <h3
              [id]="headerId"
              left1
              role="heading"
              class="app-header-3 tw-truncate"
              >
              {{ label | translation: translationRequest }}
            </h3>
          }
          <div right1>
            <button
              mat-icon-button
              matDialogClose
              (click)="onClearClicked()"
              [attr.aria-label]="'Close Modal' | translation: translationRequest"
              >
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </app-action-row>
      }
      <div id="dialogContent" class="tw-flex-grow tw-overflow-auto tw-p-4">
        <ng-content></ng-content>
      </div>
    </div>
    `,
    styles: [``],
    standalone: false
})
export class DialogContainerComponent implements OnInit {
  @Input() label: string;
  @Input() showHeader: boolean = true;
  templateToRender: boolean = true;
  @Output() clearClicked = new EventEmitter<void>();
  @Input() ariaLabel: string = '';
  @Input()
  headerLevel = 2;
  @Input()
  headerId: string = '';
  @Input() twoColHeader: boolean = false;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });
  
  constructor(private rendered: Renderer2) {}
  ngOnInit() {}

  onClearClicked() {
    this.clearClicked.emit();
  }
}
